import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { x3VarijantaData } from '../views/templates/otp/data'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const StandaloneContainer = () => import('@/containers/StandaloneContainer')
const HomeContainer = () => import('@/containers/HomeContainer')

// Views
const Login = () => import('@/views/users/Login')
const TwoFactorAuth = () => import('@/views/users/TwoFactorAuth')
const Register = () => import('@/views/users/Register')
const ProjectInvite = () => import('@/views/users/ProjectInvite')
const ForgotPassword = () => import('@/views/users/ForgotPassword')
const ResetPassword = () => import('@/views/users/ResetPassword')
const Dashboard = () => import('@/views/Dashboard')
const Home = () => import('@/views/Home')
const Projects = () => import('@/views/projects/Index')
const Widgets = () => import('@/views/widgets/Index')
const Workspace = () => import('@/views/workspace/Index')
const Templates = () => import('@/views/templates/Index')
const Events = () => import('@/views/events/Index')
const PublicScout = () => import('@/views/publicScout/Index')
const WorkflowScout = () => import('@/views/scout/workflow/Index')
const Integrations = () => import('@/views/integrations/Index')
const IntegrationSettings = () => import('@/views/integrations/IntegrationSettings')
const IntegrationPage = () => import('@/views/integrations/IntegrationPage')
const Settings = () => import('@/components/base/Settings')
const ComponentsEditor = () => import('@/components/base/Editor')
const CheckoutIndex = () => import('@/views/checkout/Index')
const CheckoutThenkYou = () => import('@/views/checkout/ThankYou')
const AppIndex = () => import('@/views/apps/Index')
const App = () => import('@/views/apps/App')
const AppList = () => import('@/views/apps/List')
const AppPlayground = () => import('@/views/apps/Playground')
const AppEditor = () => import('@/views/apps/Editor')
const AppSettings = () => import('@/views/apps/Settings')
const PublicAppList = () => import('@/views/publicapps/List')
const PublicAppIndex = () => import('@/views/publicapps/Index')
const PublicAppEditor = () => import('@/views/publicapps/Editor')
const PublicAppSettings = () => import('@/views/publicapps/Settings')
const DeveloperIndex = () => import('@/views/developer/Index')
const ThunderIndex = () => import('@/views/developer/thunder/Index')
const Thunder = () => import('@/views/developer/thunder/Thunder')
const ThunderList = () => import('@/views/developer/thunder/ThunderList')
const SparkIndex = () => import('@/views/developer/spark/Index')
const Spark = () => import('@/views/developer/spark/Spark')
const SparkCreate = () => import('@/views/developer/spark/Create')
const SparkList = () => import('@/views/developer/spark/SparkList')
const Ratchet = () => import('@/views/developer/ratchet/Index')
const RatchetList = () => import('@/views/developer/ratchet/List')
const RatchetCreate = () => import('@/views/developer/ratchet/Create')
const RatchetEdit = () => import('@/views/developer/ratchet/Edit')

const FunctionsIndex = () => import('@/views/developer/functions/Index')
const FunctionList = () => import('@/views/developer/functions/List')
const FunctionCreate = () => import('@/views/developer/functions/Create')
const FunctionEdit = () => import('@/views/developer/functions/Edit')

const GlobalEnvironment = () => import('@/views/globalEnv')

const ProjectsList = () => import('@/views/projects/List')
const ProjectCreate = () => import('@/views/projects/Create')
const ProjectSettings = () => import('@/views/projects/Settings')

const WidgetsList = () => import('@/views/widgets/List')
const WidgetEdit = () => import('@/views/widgets/Edit')
const WidgetCreate = () => import('@/views/widgets/Create')

const WorkspaceList = () => import('@/views/workspace/List')
const WorkspaceEdit = () => import('@/views/workspace/Edit')
const WorkspaceCreate = () => import('@/views/workspace/Create')

const TemplateList = () => import('@/views/templates/List')

const EventView = () => import('@/views/events/View')
const EventsList = () => import('@/views/events/List')
const EventsSettings = () => import('@/views/events/Settings')

const PublicList = () => import('@/views/publicScout/List')
const PublicInspect = () => import('@/views/publicScout/Inspect')

const Users = () => import('@/views/users/Index')
const UserProfile = () => import('@/views/users/Profile')
const UserInvite = () => import('@/views/users/Invite')
const UserCreate = () => import('@/views/users/Create')
const UserEdit = () => import('@/views/users/Edit')
const ApiUserEdit = () => import('@/views/users/EditApiUser')
const UserRoles = () => import('@/views/users/role/Index')
const UserRolesCreate = () => import('@/views/users/role/Create')
const UserRolesEdit = () => import('@/views/users/role/Edit')
const UserCreditsHistory = () => import('@/views/users/CreditsHistory')

const PageResolver = () => import('@/views/pages/PageResolver')
const Changelog = () => import('@/views/updates/Index')

const ComponentsCreate = () => import('@/views/components/Create')
const ComponentsList = () => import('@/views/components/List')

const WorkflowIndex = () => import('@/views/workflow/Index')
const Workflow = () => import('@/views/workflow/Workflow')

const LandingPage = () => import('@/views/templates/LandingPage')

const OTPLandingPage = () => import('@/views/templates/otp/components/X3Varijanta')
const PwaInstall = () => import('@/views/pages/PwaInstall')
const ProjectLandingPage = () => import("@/views/pages/ProjectLandingPage")

const Dung = () => import('@/views/Dung')

Vue.use(Router)

export function authGuard(to, from, next) {
  store.dispatch("fetchClaims").then((claims) => {
    if (claims.ProjectUUID) {
      next()
      return
    }
    
    next("/?force=true")
  }).catch(() => {
    console.log("Error")
    next("/login")
  })
}

let router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      component: PageResolver,
    },
    {
      path: '/dung',
      component: Dung,
    },
    {
      path: '/',
      component: ProjectLandingPage,
    },
    {
      path: '/app/editor/:id',
      beforeEnter: authGuard,
      name: 'Editor',
      component: AppEditor
    },
    {
      path: '/public-app/editor/:id',
      beforeEnter: authGuard,
      name: 'Editor',
      component: PublicAppEditor
    },
    {
      path: '/component/editor/:id',
      beforeEnter: authGuard,
      name: 'Editor',
      component: ComponentsEditor
    },
    {
      path: '/template/:id',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: CheckoutIndex
    },
    {
      path: '/checkout/thankyou',
      name: 'CheckoutThenkYou',
      component: CheckoutThenkYou
    },
    {
      path: '/admin',
      beforeEnter: authGuard,
      component: DefaultContainer,
      redirect: '/admin/dashboard',
      children: [
        {
          path: '/admin/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            label: 'dashboard'
          }
        },
        {
          path: '/admin/components/create',
          name: 'ComponentsCreate',
          component: ComponentsCreate,
          meta: {
            label: 'componentCreate'
          }
        },
        {
          path: '/admin/component/:ref/settings',
          name: 'Settings',
          component: Settings,
          meta: {
            label: 'settings'
          }
        },
        {
          path: '/admin/components',
          name: 'ComponentsList',
          component: ComponentsList,
          meta: {
            label: 'components'
          }
        },
        {
          path: '/admin/public-app',
          name: 'PublicApp',
          component: PublicAppIndex,
          meta: {
            label: 'publicApps'
          },
          children: [
            {
              path: '',
              name: 'PublicAppList',
              component: PublicAppList
            },
            {
              path: ':id',
              name: 'PublicAppSettings',
              component: PublicAppSettings
            }
          ]
        },
        {
          path: '/admin/app',
          name: 'App',
          component: AppIndex,
          meta: {
            label: 'apps'
          },
          children: [
            {
              path: '',
              name: 'List',
              component: AppList,
              meta: {
                label: 'appList'
              }
            },
            {
              path: ':id',
              name: 'App',
              component: App,
              meta: {
                label: 'app'
              }
            },
            {
              path: 'settings/:id',
              name: 'AppSettings',
              component: AppSettings,
              meta: {
                label: 'appSettings'
              }
            }
          ]
        },
        {
          path: '/admin/thunder',
          name: 'Thunder',
          component: ThunderIndex,
          meta: {
            label: 'thunder'
          },
          badge: {
            text: 'beta'
          },
          children: [
            {
              path: '',
              name: 'Thunder',
              component: ThunderList,
              meta: {
                label: 'thunderList'
              }
            },
            {
              path: ':name',
              name: 'Thunder',
              component: Thunder,
              meta: {
                label: 'thunder'
              }
            },
          ]
        },
        {
          path: '/admin/spark',
          name: 'Spark',
          component: SparkIndex,
          meta: {
            label: 'Index'
          },
          badge: {
            text: 'beta'
          },
          children: [
            {
              path: '',
              name: 'Spark',
              component: SparkList
            },
            {
              path: 'create',
              name: 'Create',
              component: SparkCreate
            },
            {
              path: ':id',
              name: 'Spark',
              component: Spark
            },
          ]
        },
        {
          path: '/admin/ratchet',
          name: 'ratchet',
          component: Ratchet,
          meta: {
            label: 'Index'
          },
          badge: {
            text: 'beta'
          },
          children: [
            {
              path: '',
              meta: {
                label: 'Ratchet'
              },
              name: 'RatchetList',
              component: RatchetList
            },
            {
              path: 'create',
              meta: {
                label: 'create'
              },
              name: 'RatchetCreate',
              component: RatchetCreate
            },
            {
              path: 'edit/:id',
              meta: {
                label: 'edit'
              },
              name: 'RatchetEdit',
              component: RatchetEdit
            }
          ]
        },
        {
          path: '/admin/functions',
          name: 'functions',
          component: FunctionsIndex,
          meta: {
            label: 'Index'
          },
          badge: {
            text: 'beta'
          },
          children: [
            {
              path: '',
              meta: {
                label: 'Functions'
              },
              name: 'FunctionList',
              component: FunctionList
            },
            {
              path: 'create',
              meta: {
                label: 'create'
              },
              name: 'FunctionCreate',
              component: FunctionCreate
            },
            {
              path: ':id',
              meta: {
                label: 'edit'
              },
              name: 'FunctionEdit',
              component: FunctionEdit
            }
          ]
        },
        {
          path: '/admin/developer',
          name: 'Developer',
          component: DeveloperIndex,
          meta: {
            label: 'Developer'
          }
        },
        {
          path: '/admin/workflow',
          name: 'Workflow',
          component: WorkflowIndex,
          children: [
            {
              path: ':id',
              component: Workflow
            }
          ]
        },
        {
          path: '/admin/projects',
          name: 'Projects',
          redirect: { name: 'List' },
          component: Projects,
          children: [
            {
              path: '',
              name: 'List',
              component: ProjectsList
            },
            {
              path: 'create',
              name: 'Create',
              component: ProjectCreate
            },
            {
              path: 'settings',
              name: 'Settings',
              component: ProjectSettings
            }
          ]
        },
        {
          path: '/admin/widgets',
          name: 'Widgets',
          redirect: { name: 'widgets.List' },
          component: Widgets,
          children: [
            {
              path: '',
              name: 'widgets.List',
              component: WidgetsList,
              meta: {
                label: 'List'
              }
            },
            {
              path: 'edit/:id',
              name: 'Edit',
              component: WidgetEdit
            },
            {
              path: 'create',
              name: 'Create',
              component: WidgetCreate
            }
          ]
        },
        {
          path: '/admin/workspace',
          name: 'Workspace',
          redirect: { name: 'workspace.List' },
          component: Workspace,
          children: [
            {
              path: '',
              name: 'workspace.List',
              component: WorkspaceList,
              meta: {
                label: 'List'
              }
            },
            {
              path: 'edit/:id',
              name: 'Edit',
              component: WorkspaceEdit
            },
            {
              path: 'create',
              name: 'Create',
              component: WorkspaceCreate
            }
          ]
        },
        {
          path: '/admin/templates',
          name: 'Templates',
          redirect: { name: 'templates.List' },
          component: Templates,
          meta: {
            label: 'templates'
          },
          children: [
            {
              path: '',
              name: 'templates.List',
              component: TemplateList,
              meta: {
                label: 'templates'
              }
            }
          ]
        },
        {
          path: '/admin/scout/events',
          name: 'Events',
          redirect: { name: 'events.List' },
          component: Events,
          children: [
            {
              path: '',
              name: 'events.List',
              component: EventsList,
              meta: {
                label: 'List'
              }
            },
            {
              path: 'settings',
              name: 'events.Settings',
              component: EventsSettings,
              meta: {
                label: 'Settings'
              }
            },
            {
              path: ':id',
              name: 'View',
              component: EventView
            }
          ]
        },
        {
          path: '/admin/scout/api',
          name: 'API',
          component: PublicScout,
          children: [
            {
              path: '',
              name: 'List',
              component: PublicList
            },
            {
              path: 'inspect',
              name: 'Inspect',
              component: PublicInspect
            }
          ]
        },
        {
          path: '/admin/scout/workflow',
          name: 'WorkflowScout',
          component: WorkflowScout
        },
        {
          path: '/admin/environment',
          name: 'GlobalEnvironment',
          component: GlobalEnvironment
        },
        {
          path: '/admin/integrations',
          name: 'Integrations',
          component: Integrations,
          meta: {
            label: 'integrations.title'
          },
          children: [
            {
              path: ':id',
              name: 'Settings',
              component: IntegrationSettings,
              meta: {
                label: 'settings'
              }
            }
          ]
        },
        // {
        //   path: '/admin/satellites',
        //   name: 'Satellites',
        //   component: Satellites,
        //   children: [
        //     {
        //       path: '',
        //       name: 'List',
        //       component: SatelliteList
        //     },
        //     {
        //       path: ':id',
        //       name: 'Settings',
        //       component: SatelliteSettings
        //     }
        //   ]
        // },
        {
          path: '/admin/integrations/page/:id',
          component: IntegrationPage,
          children: []
        },
        {
          path: '/admin/users',
          redirect: '',
          name: 'Users',
          component: Users,
          meta: {
            settingsPath: "/admin/users/settings"
          }
        },
        {
          path: '/admin/users/edit/:id',
          redirect: '',
          name: 'UserEdit',
          component: UserEdit,
          meta: {
            label: 'editUser'
          }
        },
        {
          path: '/admin/users/api-user/edit/:id',
          redirect: '',
          name: 'ApiUserEdit',
          component: ApiUserEdit,
          meta: {
            label: 'editUser'
          }
        },
        {
          path: '/admin/users/roles',
          redirect: '',
          name: 'UserRoles',
          component: UserRoles,
          meta: {
            label: 'userRoles'
          }
        },
        {
          path: '/admin/users/roles/create',
          redirect: '',
          name: 'RolesCreate',
          component: UserRolesCreate,
          meta: {
            label: 'roleCreate'
          }
        },
        {
          path: '/admin/users/roles/edit/:id',
          redirect: '',
          name: 'RolesEdit',
          component: UserRolesEdit,
          meta: {
            label: 'roleEdit'
          }
        },
        {
          path: '/admin/users/invite',
          redirect: '',
          name: 'UserInvite',
          component: UserInvite,
          meta: {
            label: 'inviteUser'
          }
        },
        {
          path: '/admin/users/create',
          redirect: '',
          name: 'ApiUserCreate',
          component: UserCreate,
          meta: {
            label: 'createApiUser'
          }
        },
        {
          path: '/admin/users/credits/history',
          redirect: '',
          name: 'UserCreditsHistory',
          component: UserCreditsHistory,
          meta: {
            label: 'creditsHistory'
          }
        }
      ]
    },
    {
      path: '/app',
      beforeEnter: authGuard,
      name: 'AppContainer',
      component: StandaloneContainer,
      children: [

        {
          path: 'playground',
          name: 'Playground',
          component: AppPlayground,
        },
        
        {
          path: ':id',
          name: 'App',
          component: App
        }
      ]
    },
    {
      path: '/home',
      beforeEnter: authGuard,
      name: 'HomeContainer',
      component: HomeContainer,
      children: [
        {
          path: '',
          name: 'Home',
          component: Home,
          meta: {
            label: 'home'
          }
        },
        {
          path: '/users/profile',
          redirect: '',
          name: 'UserProfile',
          component: UserProfile,
          meta: {
            label: 'myProfile'
          }
        },
        {
          path: '/platform/updates',
          name: 'Updates',
          component: Changelog
        },
        {
          path: '/integrations/page/:id',
          component: IntegrationPage,
          children: []
        },
        {
          path: '/component/:ref/settings',
          name: 'Settings',
          component: Settings,
          meta: {
            label: 'settings'
          }
        },
      ]
    },
    {
      path: '',
      redirect: "/login"
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        ignoreBreadcrumb: true
      }
    },
    {
      path: '/two-factor-auth',
      name: 'TwoFactorAuth',
      component: TwoFactorAuth,
      meta: {
        ignoreBreadcrumb: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        ignoreBreadcrumb: true
      }
    },
    {
      path: '/project/invite/:uuid',
      name: 'ProjectInvite',
      component: ProjectInvite,
      meta: {
        ignoreBreadcrumb: true
      }
    },
    {
      path: '/user/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        ignoreBreadcrumb: true
      }
    },
    {
      path: '/user/resetpassword/:uuid',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        ignoreBreadcrumb: true
      }
    },

    {
      path: '/otp',
      name: "OTPLandingPage",
      component: OTPLandingPage,
      props: {
        ...x3VarijantaData
      },
      meta: {
        ignoreBreadcrumb: true
      }
    },
    {
      path: '/mobile',
      name: "Mobile",
      component: PwaInstall,
      meta: {
        ignoreBreadcrumb: true
      }
    }
  ]
})


router.beforeEach((to, from, next) => {
  // store for breadcrumbs
  if (!to.meta.ignoreBreadcrumb)
    store.commit('BREADCRUMB', to)

  next()
})

export default router